function Risk(reasonCode, reasonDescription) {
	this.ReasonCode = reasonCode;
	this.ReasonDescription = reasonDescription;
}

module.exports = Risk;


//////////////////
// WEBPACK FOOTER
// ./models/risk.js
// module id = 47
// module chunks = 0 5 20